
import type { ICalendarContext } from './calendar-context'
import { createContext } from 'react'

export const CalendarContext = createContext({} as ICalendarContext)
